module.exports = __webpack_public_path__ + "img/AdobeStock_255036539.c1a19b2d.jpeg";